import { ButtonV2, styled } from '@withjoy/joykit';

export const StyledCta = styled(ButtonV2)``;
